/**
 * @author      Shivani Mehra
 * @date        Oct, 2025
 * @copyright   www.ibirdsservices.com
 */

import * as constants from '../constants/CONSTANT';
import axios from 'axios';
import authApi from './authApi';

export default class WatconnectApi {
  constructor(path) {
    this.token = localStorage.getItem('watconnect_token');
    this.refreshToken = localStorage.getItem('watconnect_refresh_token');
    this.baseUrl = `${constants.Watconnect_API_BASE_URL}/api/${path}`;
  }

  setToken(token, refreshToken) {
    this.token = token;
    this.refreshToken = refreshToken;
    localStorage.setItem('watconnect_token', token);
    localStorage.setItem('watconnect_refresh_token', refreshToken);
  }

  async login(credentials) {
    try {
      const loginUrl = `${constants.Watconnect_API_BASE_URL}/api/auth/login`;

      const res = await axios.post(loginUrl, credentials, {
        headers: { 'Content-Type': 'application/json' },
      });

      const result = res.data;
      if (result.success) {
        this.setToken(result.authToken, result.refreshToken);
      }
      return result;
    } catch (error) {
      console.error('WatConnect login error:', error);
      throw error?.response?.data || error;
    }
  }

  async fetchAll(queryString = '') {
    const url = queryString ? `${this.baseUrl}?${queryString}` : this.baseUrl;
    const res = await axios.get(url, {
      headers: { Authorization: this.token },
    });
    return res.data;
  }

  async fetchById(id) {
    const url = id ? `${this.baseUrl}/${id}` : this.baseUrl;
    const res = await axios.get(url, {
      headers: { Authorization: this.token },
    });
    return res.data;
  }

  async create(data) {
    const res = await axios.post(this.baseUrl, data, {
      headers: { Authorization: this.token },
    });
    return res.data;
  }

  async post(url, data) {
    // Check if data is FormData
    const isFormData = data instanceof FormData;

    const headers = {
      Authorization: this.token,
    };

    // Don't set Content-Type for FormData, let axios handle it
    if (!isFormData) {
      headers['Content-Type'] = 'application/json';
    }

    const res = await axios.post(this.baseUrl + url, data, {
      headers,
      // Add CORS configuration
      withCredentials: false,
      timeout: 120000, // 30 second timeout for file uploads
    });
    return res.data;
  }

  async put(url, data) {
    const res = await axios.put(this.baseUrl + url, data, {
      headers: { Authorization: this.token },
    });
    console.log('res', res);
    return res.data;
  }

  async get(url) {
    const res = await axios.get(this.baseUrl + url, {
      headers: { Authorization: this.token },
    });
    return res.data;
  }

  async update(data, id) {
    const res = await axios.put(`${this.baseUrl}/${id}`, data, {
      headers: { Authorization: this.token },
    });
    return res.data;
  }

  async delete(id) {
    const res = await axios.delete(`${this.baseUrl}/${id}`, {
      headers: { Authorization: this.token },
    });
    return res.data;
  }

  async deleteUrl(url) {
    const res = await axios.delete(this.baseUrl + url, {
      headers: { Authorization: this.token },
    });
    return res.data;
  }

  async deleteWithBody(url, data) {
    const res = await axios.delete(this.baseUrl + url, {
      data,
      headers: {
        Authorization: this.token,
        'Content-Type': 'application/json',
      },
    });
    return res.data;
  }

  async search(params = {}) {
    const { display_fields, ...otherParams } = params;
    const queryParams = {
      ...otherParams,
      ...(display_fields && { display_fields }),
    };

    const res = await axios.get(this.baseUrl, {
      params: queryParams,
      headers: { Authorization: this.token },
    });

    return res.data;
  }

  async upsert(data) {
    const res = await axios.post(this.baseUrl, data, {
      headers: { Authorization: this.token },
    });
    return res.data;
  }

  async patch(url, data) {
    // Detect if data is FormData
    const isFormData = data instanceof FormData;

    const headers = {
      Authorization: this.token,
    };

    if (!isFormData) {
      headers['Content-Type'] = 'application/json';
    }

    const res = await axios.patch(this.baseUrl + url, data, {
      headers,
      withCredentials: false,
      timeout: 120000,
    });
    return res.data;
  }
}
